import api from '../library/axios';

export default {
  getList(workspace_id, page, search) {
    return api({
      method: 'get',
      url: `/api/channels/${workspace_id}`,
      params: {
        page,
        search,
      },
    });
  },
  createChannel(workspace_id, payload) {
    return api({
      method: 'post',
      url: `/api/channels/${workspace_id}`,
      data: payload,
    });
  },
  delete(workspace_id, channel_id) {
    return api({
      method: 'delete',
      url: `/api/channels/${workspace_id}/${channel_id}`,
    });
  },
  templateList({
    workspace_id,
    channel_id,
  }) {
    return api({
      url: `/api/broadcast/templates/${workspace_id}/${channel_id}`,
    });
  },
  checkTelegramProfile({
    type,
    token,
    workspace_id,
  }) {
    return api({
      method: 'post',
      url: `/api/channels/${workspace_id}/inquiry`,
      data: {
        type,
        token,
      },
    });
  },
  initLinkAge({ token, code }) {
    return api({
      method: 'post',
      url: '/api/wa-embed-signup/init',
      data: {
        token,
        code,
      },
    });
  },
  getEmbedPhoneNumber(waba_id = null) {
    return api({
      url: '/api/wa-embed-signup/phone-numbers',
      params: {
        waba_id,
      },
    });
  },
  getChannelProfile({
    channel_id,
    workspace_id,
  }) {
    return api({
      url: `/api/channels/${workspace_id}/${channel_id}/profile`,
    });
  },
  updateChannelProfile({
    channel_id,
    workspace_id,
    data,
  }) {
    return api({
      method: 'patch',
      url: `/api/channels/${workspace_id}/${channel_id}/profile`,
      data,
    });
  },
  getBlogs({
    workspace_id,
    channel_id,
    page,
    search,
  }) {
    return api({
      method: 'get',
      url: `/api/channels/${workspace_id}/${channel_id}/blog`,
      params: {
        page,
        search,
      },
    });
  },
  createBlog(workspace_id, channel_id, payload) {
    return api({
      method: 'post',
      url: `/api/channels/${workspace_id}/${channel_id}/blog`,
      data: payload,
    });
  },
  editBlog(workspace_id, channel_id, payload, id) {
    return api({
      method: 'patch',
      url: `/api/channels/${workspace_id}/${channel_id}/blog/${id}`,
      data: payload,
    });
  },
  deleteBlog(workspace_id, channel_id, id) {
    return api({
      method: 'delete',
      url: `/api/channels/${workspace_id}/${channel_id}/blog/${id}`,
    });
  },
  publishBlog(workspace_id, channel_id, id, status) {
    return api({
      method: 'patch',
      url: `/api/channels/${workspace_id}/${channel_id}/blog/publish/${id}`,
      data: {
        status,
      },
    });
  },
  initLinkAgeInstagram({ token }) {
    return api({
      method: 'post',
      url: '/api/instagram-embed-signup/init',
      data: {
        token,
      },
    });
  },
  getChannelFeed({
    channel_id,
    workspace_id,
    query,
  }) {
    return api({
      url: `/api/channels/${workspace_id}/${channel_id}/feed`,
      params: query,
    });
  },
  initLinkAgeFacebookMessenger({ token }) {
    return api({
      method: 'post',
      url: '/api/fb-messenger-embed-signup/init',
      data: {
        token,
      },
    });
  },
  startContactSync(workspace_id) {
    return api({
      method: 'post',
      url: `/api/channels/${workspace_id}/sync_contact`,
    });
  },
  startMessageSync(workspace_id) {
    return api({
      method: 'post',
      url: `/api/channels/${workspace_id}/sync_message`,
    });
  },
  updateForwardNumber(workspace_id, channel_id, forward_phone_number) {
    return api({
      method: 'patch',
      url: `/api/channels/${workspace_id}/call/forward-number/${channel_id}`,
      data: {
        forward_phone_number,
      },
    });
  },
  updateOpsTime(workspace_id, channel_id, work_hour) {
    return api({
      method: 'patch',
      url: `/api/channels/${workspace_id}/call/ops-time/${channel_id}`,
      data: {
        work_hour,
      },
    });
  },
  updateIvr(workspace_id, channel_id, form_data) {
    return api({
      method: 'patch',
      url: `/api/channels/${workspace_id}/call/update-ivr/${channel_id}`,
      data: form_data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getChannelPhoneCall(workspace_id) {
    return api({
      method: 'get',
      url: `/api/channels/phone-call/${workspace_id}`,
    });
  },
  previewUrlIvr(id, workspace_id, type) {
    return api({
      url: `/api/channels/${workspace_id}/call/${id}/${type}/ivr-preview`,
    });
  },
  submitMMLite(workspace_id) {
    return api({
      method: 'post',
      url: `/api/channels/mm-lite/${workspace_id}/submit`,
    });
  },
};
